import { combineEpics } from "redux-observable";

import applicant from "./applicant/epic";
import storage from "./storage/epic";
import auth from "./auth/epic";
import user from "./user/epic";
import request from "./request/epic";
import log from "./logs/epic";
import comment from "./comment/epic";
import position from "./position/epic";
import notification from "./notification/epic";
import interviewer from "./interviewer/epic";

export default combineEpics<any>(
  applicant,
  storage,
  auth,
  user,
  request,
  log,
  comment,
  position,
  notification,
  interviewer
);
